var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-2 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.875 15.5833H2.125C1.83458 15.5833 1.59375 15.3424 1.59375 15.052C1.59375 14.7616 1.83458 14.5208 2.125 14.5208H14.875C15.1654 14.5208 15.4062 14.7616 15.4062 15.052C15.4062 15.3424 15.1654 15.5833 14.875 15.5833Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.4729 2.46607C12.0987 1.0919 10.7529 1.05648 9.34332 2.46607L8.48623 3.32315C8.4154 3.39398 8.38707 3.50732 8.4154 3.60648C8.95373 5.48357 10.4554 6.98523 12.3325 7.52355C12.3608 7.53064 12.3891 7.53772 12.4175 7.53772C12.4954 7.53772 12.5662 7.50939 12.6229 7.45272L13.4729 6.59565C14.1741 5.90148 14.5141 5.22857 14.5141 4.54857C14.5212 3.84732 14.1812 3.16732 13.4729 2.46607Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.0574 8.16759C10.852 8.06843 10.6536 7.96926 10.4624 7.85593C10.3065 7.76384 10.1578 7.66468 10.009 7.55843C9.88863 7.48051 9.74696 7.36718 9.61238 7.25384C9.59821 7.24676 9.54863 7.20426 9.49196 7.14759C9.25821 6.94925 8.99613 6.69425 8.76238 6.41091C8.74113 6.39675 8.70571 6.34716 8.65613 6.28341C8.58529 6.19841 8.46488 6.05675 8.35863 5.89383C8.27363 5.78758 8.17446 5.63175 8.08238 5.47591C7.96904 5.28466 7.86988 5.09341 7.77071 4.89508C7.75569 4.86293 7.74117 4.83093 7.72715 4.79913C7.6226 4.56303 7.31468 4.494 7.13215 4.67658L3.07447 8.73426C2.98239 8.82634 2.89739 9.00343 2.87614 9.12384L2.49364 11.8368C2.42281 12.3184 2.55739 12.7718 2.85489 13.0763C3.10989 13.3243 3.46406 13.4588 3.84656 13.4588C3.93156 13.4588 4.01656 13.4518 4.10156 13.4376L6.82156 13.0551C6.94906 13.0338 7.12613 12.9488 7.21113 12.8568L11.2637 8.80417C11.4476 8.62029 11.3783 8.3048 11.1391 8.20273C11.1122 8.19125 11.0849 8.17949 11.0574 8.16759Z",
    fill: "#313131"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.763f64cc637392e3c20e32096f6e2e92.svg";
export { ForwardRef as ReactComponent };